import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vuex from 'vuex';
import getters from './getters';
import actions from './actions';
import i18n from './modules/i18n';
import customer from './modules/customer';
import request from './modules/request';
import layer from './modules/layer';
import wishlist from './modules/wishlist';
import sharedEnv from './modules/sharedEnv';
import user from './modules/user';
export default (function () {
  return new Vuex.Store({
    actions: actions,
    getters: getters,
    modules: {
      i18n: i18n,
      customer: customer,
      request: request,
      layer: layer,
      wishlist: wishlist,
      sharedEnv: sharedEnv,
      user: user
    }
  });
});